import { QueryClientProvider as ReactQueryProvider } from "react-query";
import { queryClient } from "./reactQueryConfig";

export interface QueryClientProviderProps {
  children: React.ReactNode;
}

export const QueryClientProvider = ({ children }: QueryClientProviderProps) => (
  <ReactQueryProvider client={queryClient}>{children}</ReactQueryProvider>
);

/* eslint-disable-next-line no-barrel-files/no-barrel-files -- js to ts conversion */
export * from "./reactQueryConfig";
